import React from 'react';
import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  Tooltip,
  CartesianGrid,
  ResponsiveContainer,
  Legend,
} from 'recharts';

const data = [
  { year: '2015', AUM: 4.78 },
  { year: '2016', AUM: 6.78 },
  { year: '2017', AUM: 9.52 },
  { year: '2018', AUM: 15.71 },
  { year: '2019', AUM: 22.96 },
  { year: '2020', AUM: 21.11 },
  { year: '2021', AUM: 42.75 },
  { year: '2022', AUM: 61.49 },
  { year: '2023', AUM: 69.25 },
  { year: '2024', AUM: 106.5 },
  { year: '2025', AUM: 141.43 },
  { year: 'May 2025 (As of now)', AUM: 151 },
];

const AUMLineChart = () => {
  return (
    <div style={{ width: '100%', height: 400 }}>
      <ResponsiveContainer>
        <LineChart data={data} margin={{ top: 30, right: 30, left: 20, bottom: 10 }}>
          <CartesianGrid strokeDasharray="3 3" />
          <XAxis dataKey="year" />
          <YAxis label={{ value: 'AUM (in ₹ Crs)', angle: -90, position: 'insideLeft' }} />
          <Tooltip />
          <Legend verticalAlign="top" />
          <Line type="monotone" dataKey="AUM" stroke="#a5c94d" strokeWidth={3} dot={{ r: 5 }} activeDot={{ r: 8 }} />
        </LineChart>
      </ResponsiveContainer>
    </div>
  );
};

export default AUMLineChart;
